import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Routes, Route, Link, useNavigate } from "react-router-dom";
import "./App.css";

import AuthService from "./services/auth.service";
import Login from "./components/login.component";
import Home from "./components/home.component";
import Dashboard from "./components/dashboard.component";
import BoardAdmin from "./components/board-admin.component";
import BoardSuperAdmin from "./components/board-superadmin.component";
import Activate from "./components/activate.component";
import { Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function App() {
  const [currentUser, setCurrentUser] = useState(AuthService.getCurrentUser());
  const [backendVersion, setBackendVersion] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentUser(AuthService.getCurrentUser());
    axios.get(`${process.env.REACT_APP_API_URL}/test/version`)
      .then(res => {
        const match = res.data.match(/[\d]+\.[\d]+\.[\d]+/);
        if (match) setBackendVersion(match[0]);
      })
      .catch(() => {});
  }, []);

  const isSuperAdmin = currentUser?.roles?.includes("ROLE_SUPERADMIN");
  const isAdmin = currentUser?.roles?.includes("ROLE_ADMIN") || isSuperAdmin;
  const isUser = currentUser?.roles?.includes("ROLE_USER");

  const handleLogout = () => {
    AuthService.logout();
    setCurrentUser(null);
    navigate("/");
  };

  return (
    <div>
      <nav className="navbar">
        <Link to={currentUser ? "/dashboard" : "/"} className="navbar-brand">SmartAutomation</Link>

        <ul className="nav-links">
          {currentUser ? (
            <>
              {currentUser && <li><Link to="/dashboard" className="nav-link">Dashboard</Link></li>}
              {isAdmin && <li><Link to="/admin" className="nav-link">Admin</Link></li>}
              {isSuperAdmin && <li><Link to="/superadmin" className="nav-link">SuperAdmin</Link></li>}
              <li><span className="nav-user">{currentUser.username}</span></li>
              <li><button className="nav-logout" onClick={handleLogout}>Salir</button></li>
            </>
          ) : (
            <>
              <li><Link to="/login" className="nav-link">Iniciar sesión</Link></li>
            </>
          )}
        </ul>
      </nav>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login onLogin={setCurrentUser} />} />
        <Route path="/register" element={<Navigate to="/login" replace />} />
        <Route path="/activar" element={<Activate />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<BoardAdmin />} />
        <Route path="/superadmin" element={<BoardSuperAdmin />} />
      </Routes>

      <ToastContainer
        position="bottom-right"
        theme="dark"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
      />
      <footer style={{ textAlign: "center", padding: "12px", fontSize: 11, color: "var(--muted)", borderTop: "1px solid var(--border)" }}>
        SmartAutomation · Frontend v1.0.0{backendVersion ? ` · Backend v${backendVersion}` : ""}
      </footer>
    </div>
  );
}
